import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import { useIntl } from "react-intl";
import { UseQueryResult } from "react-query";
import { PaginatedResult } from "types/common-types";

type SelectProps = {
  applicationId?: string;
  labelField: keyof any;
  fetchedData: UseQueryResult<PaginatedResult<any>, unknown>;
  parentChange?: (v?: string) => void;
} & Omit<
  AutocompleteWithQueryProps<any>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectEntity = ({
  fetchedData,
  labelField,
  parentChange,
  onChange,
  ...rest
}: SelectProps) => {
  const { formatMessage: t } = useIntl();

  const handleOnChange = (v?: string) => {
    if (parentChange) parentChange(v);

    onChange(v);
  };

  return (
    <AutocompleteWithQuery
      {...rest}
      labelField={labelField}
      fetchedData={fetchedData}
      failMessage={t({ id: "selectFetchFailed" })}
      onChange={handleOnChange}
    />
  );
};

export default SelectEntity;
